import React from 'react'
import axios from 'axios'
import styles from './NewLandingSignup.module.scss'



class Signup extends React.Component {
    constructor(props) {
        super(props)

        const today = new Date();
        const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

        this.state = {
            firstname: '',
            lastname: '',
            email: '',
            phone: '',
            plans: '',
            gradyear: '',
            finaid: '',
            mainReason: '',
            date: date
        }

        props.fieldKey ? this.state[props.fieldKey] = props.fieldValue : null

        this.valueUpdater = this.valueUpdater.bind(this)
    }


    valueUpdater = field => (event) => {
        let value = event.target.value;
        const newState = {
          ...this.state,
          [field]: value,
        };
        this.setState(newState);
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');

        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length).replace('%20\g', ' ')
            }
        }
        return "";
    }


    get_ga_params() {
        var utmz = this.getCookie("__utmz")
        var vals = (function() {
            var pairs = utmz.split('.').slice(4).join('.').split('|');
            var ga = {};
            for (var i = 0; i < pairs.length; i++) {
                var temp = pairs[i].split('=');
                ga[temp[0]] = temp[1];
            }
            return ga;
        })();
        return vals;
    }

    getUrlParams(search) {
        let hashes = search.slice(search.indexOf('?') + 1).split('&')
        return hashes.reduce( (params, hash) => {
            let [key, val] = hash.split('=')
            return Object.assign(params, {[key]: decodeURIComponent(val)})
        }, {} )
    }

    getUTMCookies() {
        return {
            utm_source: this.getCookie('utm_source'),
            utm_medium: this.getCookie('utm_medium'),
            utm_term: this.getCookie('utm_term'),
            utm_content: this.getCookie('utm_content'),
            utm_campaign: this.getCookie('utm_campaign')
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    handleSubmit(e) {
        let gaParams = this.get_ga_params()
        //let urlParams = this.getUTMCookies()
        const user_id = this.getCookie('intercom-id-qee5suad')
        this.setState({
            utm_medium: gaParams.utmcmd ? gaParams.utmcmd : '--',
            utm_source: gaParams.utmcsr ? gaParams.utmcsr : '--',
            utm_term: gaParams.utmctr ? gaParams.utmctr : '--',
            utm_content: gaParams.utmcct ? gaParams.utmcct : '--',
            utm_campaign: gaParams.utmccn ? gaParams.utmccn : '--',
            // utm_source: urlParams.utm_source ? urlParams.utm_source : '--',
            // utm_medium: urlParams.utm_medium ? urlParams.utm_medium: '--',
            // utm_term: urlParams.utm_term ? urlParams.utm_term : '--',
            // utm_content: urlParams.utm_content ? urlParams.utm_content : '--',
            // utm_campaign: urlParams.utm_campaign ? urlParams.utm_campaign : '--',
            user_id: user_id
        }, () => {
            var url = this.props.zap
            !this.props.zap || this.props.zap == null ? url = 'https://hooks.zapier.com/hooks/catch/1060428/gte8b8/' : null

            if (this.state.email != '' && this.validateEmail(this.state.email) && this.state.firstname != '' && this.state.lastname != '' && this.state.plans != '' && this.state.gradyear != '' && this.state.finaid != '' ) {
                axios.post(url, JSON.stringify(this.state)).then( res => {
                    if (res.data.status == 'success') {
                        // window.location.replace('/welcome-quiz/')
                        typeof ORIBI !== 'undefined' ? ORIBI.api('setUserEmail', this.state.email) : null
                        var form = this.refs.form
                        form.innerHTML = `<div style="padding-top: 60px; padding-bottom: 60px"><p class="slanted" style="text-align: left;">Congrats!</p><p class="slanted" style="text-align: left;">A journey of a thousand miles begins with a single step.</p><h5 style="margin-top: 40px;"><a href="/welcome-quiz/?email=${encodeURIComponent(this.state.email)}&firstname=${encodeURIComponent(this.state.firstname)}&lastname=${encodeURIComponent(this.state.lastname)}" class="hoverlink">Take our quiz!</a></h5></div>`
                    }
                    else {
                        this.refs.error.style.display = 'block'
                        this.refs.emailError.style.display = 'none'
                    }
                })
            }
            else {
                this.refs.required.style.display = 'block'
                this.refs.reqMessage.style.display = 'block'
                if (this.validateEmail(this.state.email) ) {
                    this.refs.emailError.style.display = 'none'
                }
                else {
                    this.refs.emailError.style.display = 'block'
                }
            }
        })
  }


  render() {
    // console.log('FORM PROPS ==>', this.props);
    return (
      <div className={`${styles.Signup}${this.props.className ? ' ' : null}${this.props.className}`} ref="form">
        <div className={styles.Signup__Wrapper}>
        <h2>{this.props.title}</h2>
        <form ref="inquiryForm">
          <div className={styles.FormRow}>
            <div className={`${styles.FormElement} ${this.state.firstname !== '' ? styles.FormElementActive : ''}`}>
              <input id="firstname-entry" required type="text" name='firstname' value={this.state.firstname} onChange={this.valueUpdater('firstname')} />
              <label htmlFor="firstname-entry">First Name*</label>
            </div>
            <div className={`${styles.FormElement} ${this.state.lastname !== '' ? styles.FormElementActive : ''}`}>
              <input type="text" required id="lastname-entry" name='lastname' value={this.state.lastname} onChange={this.valueUpdater('lastname')} />
              <label htmlFor="lastname-entry">Last Name*</label>
            </div>
          </div>
          <div className={styles.FormRow}>
            <div className={`${styles.FormElement} ${this.state.email !== '' ? styles.FormElementActive : ''}`}>
              <input type="email" required id="email-entry" name='email' value={this.state.email} onChange={this.valueUpdater('email')} />
              <label htmlFor="email-entry">Email Address*</label>
              <span ref="emailError" style={{ color:'red', fontSize:'12px', display:'none' }} className="email-error">* Please enter a valid email address.</span>
            </div>
            <div className={`${styles.FormElement} ${this.state.phone !== '' ? styles.FormElementActive : ''}`}>
              <input type="text" id="number-entry" name='phone' value={this.state.phone} onChange={this.valueUpdater('phone')} />
              <label htmlFor="number-entry">Phone Number</label>
            </div>
          </div>
          <div className={styles.FormRow}>
            <div className={`${styles.FormElement} ${styles.FormElementSelect} ${this.state.plans !== '' ? styles.FormElementActive : ''}`}>
              <select name="plans" id="plans-entry" required onChange={this.valueUpdater('plans')}>
                <option value="" selected disabled hidden></option>
                <option value="definitely gap year">Definitely gap year</option>
                <option value="probably gap year">Probably gap year</option>
                <option value="probably college">Probably college</option>
                <option value="definitely college">Definitely college</option>
                <option value="working">Working</option>
                <option value="something else">Something else</option>
                <option value="i have no idea">I have no idea</option>
              </select>
              <label className={`${styles.FormElementTall__Label}`} htmlFor="plans-entry">How do you feel about your plans after high school?*</label>
            </div>
            <div className={`${styles.FormElement} ${styles.FormElementSelect} ${this.state.gradyear !== '' ? styles.FormElementActive : ''}`}>
              <select name="gradyear" id="gradyear-entry" required onChange={this.valueUpdater('gradyear')}>
                <option value="" selected disabled hidden></option>
                <option value="2019">2019</option>
                <option value="2020">2020</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
              </select>
              <label htmlFor="gradyear-entry">Year of High School graduation*</label>
            </div>
          </div>
          <div className={styles.FormRow}>
            <div className={`${styles.FormElement} ${styles.FormElementSelect} ${styles.FormElementSelect__Tall} ${this.state.finaid !== '' ? styles.FormElementActive : ''}`}>
              <select name="finaid" id="finaid-entry" required onChange={this.valueUpdater('finaid')}>
                <option value="" selected disabled hidden></option>
                <option value="full pay">I don’t think I’ll need a scholarship</option>
                <option value="high pay">I’ll need a small scholarship</option>
                <option value="high partial pay">I’ll need a partial scholarship (about half)</option>
                <option value="low partial pay">I’ll need more than a partial scholarship</option>
                <option value="low pay">I’ll need a full scholarship</option>
              </select>
              <label htmlFor="finaid-entry">Financial aid estimate...it doesn't have to be exact!*</label>
            </div>
            <div className={`${styles.FormElement} ${styles.FormElementSelect} ${styles.FormElementSelect__Tall} ${this.state.mainReason !== '' ? styles.FormElementActive : ''}`}>
                <select name="mainReason" id="mainReason-entry" required onChange={this.valueUpdater('mainReason')}>
                  <option value="" selected disabled hidden></option>
                  <option value="career">To get ahead in my career</option>
                  <option value="self discovery">To better understand myself and my purpose</option>
                  <option value="culture">To immerse myself in a new culture</option>
                  <option value="service">To have a positive impact in the world</option>
                </select>
                <label htmlFor="mainReason">What’s the main reason you are interested in  taking a gap year?*</label>
            </div>
          </div>

          <div ref="interestForm" onClick={ () => this.handleSubmit() } style={{ marginLeft: 0, marginTop:'40px' }} className={styles.Button}>
            REQUEST MORE INFO
            <svg width="21px" height="10px" viewBox="0 0 21 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
                    <g id="GCY---request-info-form-@2x-updated-Copy-4" transform="translate(-286.000000, -769.000000)" stroke="#222222" strokeWidth="1.5">
                        <g id="request-info">
                            <g id="button---submit" transform="translate(193.000000, 743.000000)">
                                <g id="Group-9" transform="translate(94.000000, 27.000000)">
                                    <polyline id="Line-2" points="15 0 19 4 15 8"></polyline>
                                    <path d="M0,4 L18,4" id="Line-3"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
          </div>
        </form>
        <div ref="required" style={{ display: 'none', marginTop:'10px' }}>
            <p style={{ color: 'red' }} ref="reqMessage">* Please fill out all required fields</p>
        </div>
        <div ref="success" style={{ display: 'none', marginTop:'10px' }}>
            <p ref="successMessage">Thank you for your submission. We will contact you shortly!</p>
        </div>
        <div ref="error" style={{ display: 'none', marginTop:'10px' }}>
            <p style={{ color: 'red' }}>Something went wrong with your sumbission. Please try again!</p>
        </div>
        </div>
      </div>
    )
  }
}

export default Signup;



// WEBPACK FOOTER //
// ./src/components/Shared/NewLandingSignup/index.js